import React, { useState } from "react";

const SignSdkTest = () => {
    const [token, setToken] = useState("");
    const [sdkData, setSdkData] = useState(null);
    const [sdkUrl, setSdkUrl] = useState("https://d1weq6qqufwk54.cloudfront.net/sign_macm_uat.js");

    const fetchToken = () => {
        const apiUrl =
            "https://jc2l8chno8.execute-api.ap-south-1.amazonaws.com/default/TokenCheck";

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "Iq0wt1I0D13WeEIlItpIY39LIDFC71I16kxv6uDk"
            },
            body: JSON.stringify({ key: "MEs4G1V7Ba6", clientName: "Mirae" }),
        };

        fetch(apiUrl, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setToken(data.body);
            })
            .catch((error) => {
                console.error("Error fetching token:", error);
            });
    };

    const handleSDKData = (data) => {
        setSdkData(data);
    };

    const initializeSDK = () => {
        // Dynamically load the script from sdkUrl
        const script = document.createElement("script");
        script.src = sdkUrl;
        script.async = true;

        script.onload = () => {
            if (window.AinxtSDK && token) {
                window.AinxtSDK.Initialize(token, handleSDKData);
            } else {
                alert("SDK not loaded or token missing");
            }
        };

        script.onerror = () => {
            alert("Failed to load SDK script.");
        };

        document.head.appendChild(script);
    };

    return (
        <div className="text-center">
            <h1 className="text-4xl font-bold mb-8">Signature SDK Test1</h1>
            <button
                className="bg-blue-500 hover:bg-blue-700 text-dark font-bold py-2 px-4 rounded"
                onClick={fetchToken}
            >
                Get Token
            </button>
            <input
                type='text'
                placeholder="Paste SDK script URL"
                style={{ border: '1px solid red', marginLeft: 8, width: 400 }}
                value={sdkUrl}
                onChange={(e) => setSdkUrl(e.target.value)}
            />
            {token && (
                <button
                    className="mt-4 bg-green-500 hover:bg-green-700 text-dark font-bold py-2 px-4 rounded"
                    onClick={initializeSDK}
                >
                    Initialize AinxtSDK
                </button>
            )}
            {sdkData && (
                <div className="mt-4">
                    <h2 className="text-xl font-bold mb-2">Data from SDK:</h2>
                    <pre className="whitespace-pre-wrap font-bold">{JSON.stringify(sdkData, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default SignSdkTest;